"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;

var _react = _interopRequireWildcard(require("react"));

var _propTypes = _interopRequireDefault(require("prop-types"));

var _classnames = _interopRequireDefault(require("classnames"));

var _keyname = _interopRequireDefault(require("keyname"));

var _Scrim = _interopRequireDefault(require("../Scrim"));

var _viewport = require("../../utils/viewport");

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { "default": obj }; }

function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } else { var newObj = {}; if (obj != null) { for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) { var desc = Object.defineProperty && Object.getOwnPropertyDescriptor ? Object.getOwnPropertyDescriptor(obj, key) : {}; if (desc.get || desc.set) { Object.defineProperty(newObj, key, desc); } else { newObj[key] = obj[key]; } } } } newObj["default"] = obj; return newObj; } }

function _typeof(obj) { if (typeof Symbol === "function" && typeof Symbol.iterator === "symbol") { _typeof = function _typeof(obj) { return typeof obj; }; } else { _typeof = function _typeof(obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; }; } return _typeof(obj); }

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i] != null ? arguments[i] : {}; var ownKeys = Object.keys(source); if (typeof Object.getOwnPropertySymbols === 'function') { ownKeys = ownKeys.concat(Object.getOwnPropertySymbols(source).filter(function (sym) { return Object.getOwnPropertyDescriptor(source, sym).enumerable; })); } ownKeys.forEach(function (key) { _defineProperty(target, key, source[key]); }); } return target; }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

function _slicedToArray(arr, i) { return _arrayWithHoles(arr) || _iterableToArrayLimit(arr, i) || _nonIterableRest(); }

function _nonIterableRest() { throw new TypeError("Invalid attempt to destructure non-iterable instance"); }

function _iterableToArrayLimit(arr, i) { var _arr = []; var _n = true; var _d = false; var _e = undefined; try { for (var _i = arr[Symbol.iterator](), _s; !(_n = (_s = _i.next()).done); _n = true) { _arr.push(_s.value); if (i && _arr.length === i) break; } } catch (err) { _d = true; _e = err; } finally { try { if (!_n && _i["return"] != null) _i["return"](); } finally { if (_d) throw _e; } } return _arr; }

function _arrayWithHoles(arr) { if (Array.isArray(arr)) return arr; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } }

function _createClass(Constructor, protoProps, staticProps) { if (protoProps) _defineProperties(Constructor.prototype, protoProps); if (staticProps) _defineProperties(Constructor, staticProps); return Constructor; }

function _possibleConstructorReturn(self, call) { if (call && (_typeof(call) === "object" || typeof call === "function")) { return call; } return _assertThisInitialized(self); }

function _getPrototypeOf(o) { _getPrototypeOf = Object.setPrototypeOf ? Object.getPrototypeOf : function _getPrototypeOf(o) { return o.__proto__ || Object.getPrototypeOf(o); }; return _getPrototypeOf(o); }

function _assertThisInitialized(self) { if (self === void 0) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function"); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, writable: true, configurable: true } }); if (superClass) _setPrototypeOf(subClass, superClass); }

function _setPrototypeOf(o, p) { _setPrototypeOf = Object.setPrototypeOf || function _setPrototypeOf(o, p) { o.__proto__ = p; return o; }; return _setPrototypeOf(o, p); }

function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

var SideBar =
/*#__PURE__*/
function (_Component) {
  _inherits(SideBar, _Component);

  function SideBar() {
    var _this;

    _classCallCheck(this, SideBar);

    _this = _possibleConstructorReturn(this, _getPrototypeOf(SideBar).call(this));

    _defineProperty(_assertThisInitialized(_this), "menuItems", []);

    _this.onKeyDown = _this.onKeyDown.bind(_assertThisInitialized(_this));
    _this.onResize = _this.onResize.bind(_assertThisInitialized(_this));
    _this.state = {
      focusIndex: 0,
      wide: (0, _viewport.isWide)()
    };
    return _this;
  }

  _createClass(SideBar, [{
    key: "componentDidMount",
    value: function componentDidMount() {
      window.addEventListener('resize', this.onResize);
    }
  }, {
    key: "componentWillUnmount",
    value: function componentWillUnmount() {
      window.removeEventListener('resize', this.onResize);
    }
  }, {
    key: "onResize",
    value: function onResize() {
      var wide = (0, _viewport.isWide)();

      if (wide === this.state.wide) {
        return;
      }

      this.setState({
        wide: wide
      });
    }
  }, {
    key: "onKeyDown",
    value: function onKeyDown(e) {
      var _this$props = this.props,
          children = _this$props.children,
          onDismiss = _this$props.onDismiss;
      var focusIndex = this.state.focusIndex;
      var key = (0, _keyname["default"])(e.which);

      switch (key) {
        case 'up':
          {
            var newFocusIndex = focusIndex === 0 ? _react.Children.count(children) - 1 : focusIndex - 1;
            e.preventDefault();
            this.setState({
              focusIndex: newFocusIndex
            });
            this.menuItems[newFocusIndex].focus();
            break;
          }

        case 'down':
          {
            var _newFocusIndex = focusIndex === _react.Children.count(children) - 1 ? 0 : focusIndex + 1;

            e.preventDefault();
            this.setState({
              focusIndex: _newFocusIndex
            });

            this.menuItems[_newFocusIndex].focus();

            break;
          }

        case 'esc':
          onDismiss();
          break;
      }
    }
  }, {
    key: "componentDidUpdate",
    value: function componentDidUpdate(prevProps) {
      var show = this.props.show;

      if (prevProps.show === show) {
        return;
      }

      this.animate();
    }
  }, {
    key: "animate",
    value: function animate() {
      var _this2 = this;

      var show = this.props.show;

      var _ref = show ? ['dqpl-show', 'dqpl-show dqpl-active'] : ['dqpl-show', ''],
          _ref2 = _slicedToArray(_ref, 2),
          first = _ref2[0],
          second = _ref2[1];

      this.setState({
        animateClass: first
      }); // css3 animations require transition classes to be added on separate tics

      setTimeout(function () {
        _this2.setState({
          animateClass: second
        });

        if (show) {
          _this2.menuItems[_this2.state.focusIndex].focus();
        }
      }, 100); // slide out animation requires a min timeout of 100ms
    }
  }, {
    key: "render",
    value: function render() {
      var _this3 = this;

      this.menuItems = [];
      var _this$state = this.state,
          focusIndex = _this$state.focusIndex,
          animateClass = _this$state.animateClass,
          wide = _this$state.wide; // disabling no-unused-vars to prevent onDismiss from being passed through to dom element
      // eslint-disable-next-line no-unused-vars

      var _this$props2 = this.props,
          children = _this$props2.children,
          className = _this$props2.className,
          show = _this$props2.show,
          onDismiss = _this$props2.onDismiss,
          other = _objectWithoutProperties(_this$props2, ["children", "className", "show", "onDismiss"]);

      var listProps = _objectSpread({}, other);

      if (!wide) {
        listProps['aria-expanded'] = show;
      }

      return _react["default"].createElement(_react.Fragment, null, _react["default"].createElement("ul", _extends({
        role: "menu",
        className: (0, _classnames["default"])('dqpl-side-bar', className, animateClass)
      }, listProps), _react.Children.map(children, function (child, index) {
        return (0, _react.cloneElement)(child, {
          key: index,
          onKeyDown: _this3.onKeyDown,
          tabIndex: focusIndex === index ? 0 : -1,
          menuItemRef: function menuItemRef(menuItem) {
            return _this3.menuItems[index] = menuItem;
          }
        });
      })), _react["default"].createElement(_Scrim["default"], {
        show: !wide && show
      }));
    }
  }]);

  return SideBar;
}(_react.Component);

exports["default"] = SideBar;

_defineProperty(SideBar, "propTypes", {
  children: _propTypes["default"].node.isRequired,
  onDismiss: _propTypes["default"].func.isRequired,
  className: _propTypes["default"].string,
  show: _propTypes["default"].bool
});

_defineProperty(SideBar, "defaultProps", {
  className: '',
  show: false
});